import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/site/Seo';

export function NotFoundPage() {
  return (
    <>
      <Seo title='Page not found | Rivelin Robotics' description='The page you requested could not be found.' noIndex={true} />
      <section className='page-shell not-found-shell'>
        <p className='section-label'>404</p>
        <h1>The page you were looking for has moved.</h1>
        <p className='hero-body'>
          The rebuild introduced a cleaner information architecture, so some older routes now redirect and some content has been consolidated.
        </p>
        <div className='hero-actions'>
          <Link className='primary-cta' to='/'>
            Return home
          </Link>
          <Link className='secondary-cta' to='/contact'>
            Contact Rivelin
          </Link>
        </div>
      </section>
    </>
  );
}
